import { render, staticRenderFns } from "./intermediaryAudit.vue?vue&type=template&id=480ebe8d&scoped=true"
import script from "./intermediaryAudit.vue?vue&type=script&lang=js"
export * from "./intermediaryAudit.vue?vue&type=script&lang=js"
import style0 from "./intermediaryAudit.vue?vue&type=style&index=0&id=480ebe8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "480ebe8d",
  null
  
)

export default component.exports